import * as React from 'react';
import ModalDefault from './ModalDefault';
import { IoCloseSharp } from 'react-icons/io5';

interface ModalCustomDefault {
  visible: boolean;
  title: string;
  children: React.ReactNode;
  height?: string;
  overflow?: boolean;
  containerOverflow?: string;
  header?: boolean;
  useBlur?: boolean;
  headerWidth?: string;
  subTitle?: string;
  onClose: () => void;
  useHeaderButton?: boolean;
  zIndex?: string;
  position?: string;
  isAccountSms?: boolean;
  doNotBorder?: boolean;
}

import { d_flex_center, d_flex_space_between } from '../../styles/common';
import { styled, Box, Typography } from '@mui/material';

const StyledIconWrap = styled(Box)(props => ({
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  cursor: 'pointer',
  backgroundColor: props.theme.palette.white.main,
  color: props.theme.palette.red.main,
  svg: {
    width: '1.7rem',
    height: '1.7rem',
    strokeWidth: 30,
    marginRight: '-1px',
  },
  ...d_flex_center,
}));

interface StyledModalCustomProps {
  containerOverflow?: string;
  isOverflow?: boolean;
}

const StyledModalCustom = styled(Box)<StyledModalCustomProps>(props => ({
  height: 'auto',
  borderRadius: '6px',
  overflow: props.containerOverflow ? props.containerOverflow : props.isOverflow ? 'visible' : 'unset',
  backgroundColor: props.theme.palette.white.main,
}));

interface StyledHeaderProps {
  headerWidth?: string;
  height?: string;
}

const StyledHeader = styled(Box)<StyledHeaderProps>(props => ({
  width: props.headerWidth ? props.headerWidth : '100%',
  height: props.height ? props.height : '3.5rem',
  padding: '0 1rem',
  fontSize: '1.1rem',
  // backgroundColor: '#f12211',
  background: 'linear-gradient(0deg, rgba(242,36,19,1) 0%, rgba(255,85,58,1) 100%)',
  color: props.theme.palette.white.main,
  ...d_flex_space_between,

  '&.message_format': {
    justifyContent: 'flex-end',
    position: 'relative',
    height: '4rem',
    span: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      fontWeight: 400,
      b: {
        fontSize: '1.1rem',
        fontWeight: 600,
      },
    },
  },
}));

function ModalCustomDefault(props: ModalCustomDefault) {
  const visible = props.visible;
  const title = props.title;
  const children = props.children;
  const onClose = props.onClose;
  const height = props.height;
  const overflow = props.overflow;
  const header = props.header;
  const use_blur = props.useBlur;
  const container_overflow = props.containerOverflow;
  const header_width = props.headerWidth;
  const sub_title = props.subTitle;
  const use_header_button = props.useHeaderButton;
  const z_index = props.zIndex;
  const position = props.position;
  const isAccountSms = props.isAccountSms ? props.isAccountSms : false;
  const doNotBorder = props.doNotBorder;

  const message_format = title == '메시지 발송 형식';

  const ModalCustomHeader = () => {
    return (
      <>
        {message_format ? (
          <Box component={'span'}>
            <Typography component='b'>메시지 발송 형식</Typography>을 선택해주세요!
          </Box>
        ) : (
          <Box component={'span'}>
            {title}
            {sub_title ? (
              <Box component={'span'} sx={{ fontSize: '0.875rem', marginLeft: '0.25rem' }}>
                {sub_title}
              </Box>
            ) : null}
          </Box>
        )}

        {use_header_button !== false ? (
          <StyledIconWrap onClick={onClose}>
            <IoCloseSharp onClick={onClose} />
          </StyledIconWrap>
        ) : null}
      </>
    );
  };

  return (
    <>
      <ModalDefault
        visible={visible}
        onClose={() => {
          if (use_blur !== false) {
            onClose();
          }
        }}
        overflow={overflow}
        containerOverflow={container_overflow}
        zIndex={z_index}
        sx={{
          borderRadius: message_format ? '1rem' : doNotBorder ? '' : '6px',
        }}
        isAccountSms={isAccountSms}
      >
        <StyledModalCustom isOverflow={overflow} containerOverflow={container_overflow}>
          {header !== false ? (
            <StyledHeader
              height={height}
              headerWidth={header_width}
              className={message_format ? 'message_format' : ''}
              sx={{ borderRadius: doNotBorder ? '6px 6px 0 0' : '' }}
            >
              <ModalCustomHeader />
            </StyledHeader>
          ) : null}

          <Box sx={{ position: position || '' }}>{children}</Box>
        </StyledModalCustom>
      </ModalDefault>
    </>
  );
}

export default ModalCustomDefault;
